import { useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';
import { useHistory } from 'react-router';
import { useMutation } from '@tanstack/react-query';
import { Questionnaire } from '../../../../types';
import { postQuestionnaire } from '../../../../../../apis/questionnaires/requests';
import { getQuestionnaireFormData } from '../utils';

export const useCreateQuestionnaire = () => {
  const history = useHistory();

  const { data: updatedQuestionnaire, isSuccess, mutate: createQuestionnaire, isLoading } = useMutation(
    (questionnaire: Questionnaire) => {
      const formData = getQuestionnaireFormData(questionnaire);

      return postQuestionnaire(formData);
    }
  );

  const handleCreateQuestionnaire = (questionnaire: Questionnaire) => {
    createQuestionnaire(questionnaire);
  };

  useEffect(() => {
    if (isSuccess) {
      enqueueSnackbar('Questionnaire saved!', { variant: 'success' });

      history.push(String(updatedQuestionnaire._id));
    }
  }, [history, isSuccess, updatedQuestionnaire]);

  return { createQuestionnaire: handleCreateQuestionnaire, isLoading };
};
